module.exports = __webpack_public_path__ + "assets/img/menu-resources.4ee548e2.svg";